/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './WithSidebarTemplate.style';

import MainTopBar from 'src/shared/app/base/component/maintopbar/MainTopBar';
import MobileNavBar from 'src/shared/app/base/component/mobilenavbar/MobileNavBar';
import TakeOverPortal from 'src/shared/app/notification/component/TakeOverPortal';
import Container from 'src/shared/app/base/component/container/Container';
import ContentWithSidebar from 'src/shared/app/base/component/template/component/ContentWithSidebar';
import NotificationPortal from 'src/shared/app/notification/component/NotificationPortal';

const useStyles = createUseThemeStyles(styles);

type Props = {
  Switch: React.ComponentType<any>,
};

const WithSidebarTemplate = ({ Switch }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <MainTopBar />

      <div className={classes.content}>
        <NotificationPortal />
        <TakeOverPortal />
        <Container className={classes.container}>
          <ContentWithSidebar className={classes.contentInner}>
            <Switch layoutClass={classes.main} />
          </ContentWithSidebar>
        </Container>
      </div>

      <MobileNavBar />
    </div>
  );
};

export default React.memo<Props>(WithSidebarTemplate);
